

export function removeSquareBrackets(value) {
    // Remove square brackets and quotation marks
    const cleanedValue = value.replace(/[\[\]"']/g, '');
    // Add space after each comma
    const stringWithSpaces = cleanedValue.replace(/,/g, ', ');
    return stringWithSpaces;
}



// combining data and time
export function combineDateAndTime(startDate, startTime) {
  // Ensure both values exist
  if (!startDate || !startTime) return null;

  // Ensure both are Date objects
  const dateObj = new Date(startDate);
  const timeObj = new Date(startTime);

  // Validate they’re valid dates
  if (isNaN(dateObj.getTime()) || isNaN(timeObj.getTime())) {
    console.error("❌ Invalid date or time:", { startDate, startTime });
    return null;
  }

  // Combine date and time (local)
  const combined = new Date(
    dateObj.getFullYear(),
    dateObj.getMonth(),
    dateObj.getDate(),
    timeObj.getHours(),
    timeObj.getMinutes(),
    timeObj.getSeconds(),
    timeObj.getMilliseconds()
  );

  // Convert to UTC ISO string (with 'Z')
  const utcString = new Date(
    combined.getTime() - combined.getTimezoneOffset() * 60000
  ).toISOString(); // → e.g. "2025-11-27T15:15:06.229Z"

  return utcString;
}


//
export function correctDate(startDate) {
    const leadDate = new Date(startDate);
    if (leadDate) {
        const year = leadDate.getFullYear();
        const month = ("0" + (leadDate.getMonth() + 1)).slice(-2);
        const day = ("0" + leadDate.getDate()).slice(-2);
        const formattedDate = `${month}/${day}/${year}`;
        // console.log(formattedDate);
        return formattedDate;
    }
}


export function GET_CURRENT_DATE_TIME() {
  const now = new Date();

  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const dd = String(now.getDate()).padStart(2, "0");
  const hh = String(now.getHours()).padStart(2, "0");
  const min = String(now.getMinutes()).padStart(2, "0");
  const ss = String(now.getSeconds()).padStart(2, "0");
  const ms = String(now.getMilliseconds()).padStart(3, "0");

  return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}.${ms}Z`;
}